import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IPrevision } from '@models/IPrevisiones';
import { TranslateModule } from '@ngx-translate/core';
import { bloquearCientifica } from '@utils/bloquearCientifica';

@Component({
  selector: 'app-previsiones-table',
  imports: [CommonModule, FormsModule, TranslateModule, MatFormFieldModule, MatInputModule],
  providers: [DatePipe,],
  templateUrl: './previsiones-table.component.html',
  styleUrl: './previsiones-table.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrevisionesTableComponent implements OnChanges {
  bloquearCientifica = bloquearCientifica;
  readonly previsiones = input<IPrevision[]>([]);
  readonly editable = input<boolean>(false);
  readonly modifiedData = output<IPrevision[]>();
  readonly festivos = input<Date[]>([]);
  previsionesClon = signal<IPrevision[]>([]);

  // ngOnInit(): void {

  //   this.previsiones().forEach((p) => {
  //     p.data.forEach((d) => {
  //       d.isFestivo = this.isFestivo(d.fecha);
  //     });
  //   });

  //   this.logger.info(this.previsiones());
  //   this.previsionesClon.set(this.previsiones());
  //   this.logger.info(this.previsionesClon());
  // }

  ngOnChanges(): void {
    const festivosTxt = new Set(this.festivos().map(f => new Date(f).toDateString()));

    const previsionesActualizadas = this.previsiones().map(prevision => ({
      ...prevision,
      data: prevision.data.map(dato => ({
        ...dato,
        isFestivo: festivosTxt.has(new Date(dato.fecha).toDateString())
      }))
    }));

    this.previsionesClon.set(previsionesActualizadas);
  }


  onInputChange() {
    this.modifiedData.emit(this.previsionesClon());
  }

  isFestivo(date: string) {
    return this.festivos().some((f) => f.toDateString() === new Date(date).toDateString());
  }



}
